export default "__VITE_ASSET__sJLmT_nH__"